export default "__VITE_ASSET__D8Sa_E0F__"